module.exports = __webpack_public_path__ + "static/media/dobro-white-logo.34826e64.svg";